import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";

/**
 * NOTE: some of these utils are ports from article-utils in article-client. If
 * more utils are added, we should consider genericizing and extracting these
 * into a standalone module that multiple projects can use.
 */
import { unescape } from 'html-escaper';
import { PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
import { POST_TYPES } from '@nerdwallet/wp-api/constants';
import { getAuthors, getId, getPageTaxonomyDataElem, getPostTypeLabel, getSynopsis, getTitle, getType } from '@nerdwallet/wp-api/selectors/common';
import { getDateCalculatedIso } from '@nerdwallet/wp-api/utils/date';
import StructuredContent from '@nerdwallet/structured-content';
/*
 * Takes a WordPress API object and filters a subset of keys
 * to transform for what the ContentPageHeader API expects.
 *
 * @param  {Object}        author object with the shape of
 *                         {
 *                           name: {string} name of the author,
 *                           link: {string} URL pointing to the author's bio
 *                         }
 *
 * @return {Array}         author objects with the shape of the
 *                         ContentPageHeader `authors` prop.
 */

var mapAuthor = function mapAuthor(_ref) {
  var name = _ref.name,
      link = _ref.link;
  return {
    name: name,
    url: link
  };
};
/**
 * Takes the WordPress string content and unsanitizes it
 * to get the correct text.
 *
 * @param {String} wpContent html escaped wordpress content
 *                        '&amp;'
 *                        '&lt;', etc.
 *
 * @return {String}     content that is unescaped.
 *
 * @todo remove this method and it's usage once wordpress returns structured content
 *
 */


var unsanitize = function unsanitize(wpContent) {
  if (!wpContent) {
    return null;
  }

  return unescape(wpContent);
};
/**
 * Get the advertiser disclosure type for a given WP Post.
 *
 * @param {Object} entity WP Post.
 *
 * @return {string} Advertiser disclosure type.
 */


var getDisclosureType = function getDisclosureType(entity) {
  return (getPageTaxonomyDataElem(entity, 'vertical') || {}).value === 'Investing' ? PRODUCT_TYPES.INVESTING : PRODUCT_TYPES.CREDIT_CARDS;
};

var mapWordPress = function mapWordPress(entity) {
  var mappedProps;

  switch (getType(entity)) {
    // roundups render synopsis outside of the header
    case POST_TYPES.ROUNDUP:
      mappedProps = {
        synopsis: null
      };
      break;

    default:
      mappedProps = {};
  }

  return _objectSpread({
    advertiserDisclosureType: getDisclosureType(entity),
    authoringDate: getDateCalculatedIso(entity),
    authors: getAuthors(entity).map(mapAuthor),
    category: getPostTypeLabel(entity),
    id: getId(entity),
    synopsis: unsanitize(getSynopsis(entity)),
    title: unsanitize(getTitle(entity))
  }, mappedProps);
};

var mapGraphQL = function mapGraphQL(entity) {
  var _entity$authors, _entity$primaryCatego;

  return {
    advertiserDisclosureType: entity === null || entity === void 0 ? void 0 : entity.advertiserDisclosureType,
    authoringDate: (entity === null || entity === void 0 ? void 0 : entity.formattedDisplayDate) || (entity === null || entity === void 0 ? void 0 : entity.dateTimeDisplayDate),
    authors: (entity === null || entity === void 0 ? void 0 : (_entity$authors = entity.authors) === null || _entity$authors === void 0 ? void 0 : _entity$authors.map(function (_ref2) {
      var name = _ref2.name,
          link = _ref2.link;
      return {
        name: name,
        url: link
      };
    })) || [],
    category: (entity === null || entity === void 0 ? void 0 : entity.eyebrowText) || (entity === null || entity === void 0 ? void 0 : (_entity$primaryCatego = entity.primaryCategory) === null || _entity$primaryCatego === void 0 ? void 0 : _entity$primaryCatego.name),
    id: entity === null || entity === void 0 ? void 0 : entity.id,
    synopsis: (entity === null || entity === void 0 ? void 0 : entity.stringSynopsis) || ((entity === null || entity === void 0 ? void 0 : entity.structuredContentSynopsis) ?
    /*#__PURE__*/
    // <ContentPageHeader> supports rendering arbitrary nodes as the synopsis,
    // so we'll render the Structured Content here to keep
    // `@nerdwallet/structured-content` out of the import path for folks using
    // just the vanilla CPH.
    React.createElement(StructuredContent, null, entity === null || entity === void 0 ? void 0 : entity.structuredContentSynopsis) : null),
    title: entity === null || entity === void 0 ? void 0 : entity.title,
    hideAdvertiserDisclosure: !(entity === null || entity === void 0 ? void 0 : entity.showAdvertiserDisclosure),
    hideAuthorByline: !(entity === null || entity === void 0 ? void 0 : entity.showAuthorByline),
    hideEditorialStandards: !(entity === null || entity === void 0 ? void 0 : entity.showEditorialDisclaimer)
  };
};

export default (function (props) {
  // eslint-disable-next-line no-underscore-dangle
  var isGraphQLObject = !!props.wordPressEntity.__typename;
  var mappedProps = isGraphQLObject ? mapGraphQL(props.wordPressEntity) : mapWordPress(props.wordPressEntity); // Merge props to allow manual overrides.

  return _objectSpread(_objectSpread({}, mappedProps), props);
});